import React, { useEffect, useState } from "react";
import { Form, Button, Container, Row, Col, Spinner, Offcanvas, Table, Pagination } from "react-bootstrap";
import Select from "react-select";
import { LMSBASEURL } from "../../config/apiUrls";
import Swal from "sweetalert2";
import NoDataFound from "../../components/NoDataFound";

const TeacherMaterialPage = () => {
    const [show, setShow] = useState(false);

    const [programs, setPrograms] = useState([]);
    const [courses, setCourses] = useState([]);
    const [modules, setModules] = useState([]);
    const [teachers, setTeachers] = useState([]);

    const [program, setProgram] = useState(null);
    const [course, setCourse] = useState(null);
    const [module, setModule] = useState(null);
    const [teacher, setTeacher] = useState(null);

    const [file, setFile] = useState(null);
    const [filename, setFilename] = useState("");
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [showEdit, setShowEdit] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [materials, setMaterials] = useState([]);
    const [meta, setMeta] = useState({});
    const [page, setPage] = useState(1);
    const [loadingMaterial,setLoadingMaterial] = useState(false)
    const [loadProgram,setLoadProgram] = useState(false)
    const [loadModule,setLoadModule] = useState(false)
    const [uploadLoad,setUploadLoad] = useState(false)


    const token = process.env.REACT_APP_API_TOKEN;
    const instituteId = sessionStorage.getItem("instituteId");
    const loginID= sessionStorage.getItem("id");

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");

    const fetchMaterials = async (pageNo = 1) => {
    try {
        setLoadingMaterial(true);
        const res = await fetch(`${LMSBASEURL}/api/teacher-materials?institute_id=${loginID}&page=${pageNo}`, {
            method: "GET",
            headers:myHeaders,
        });
        const data = await res.json();
        setMaterials(data.data || []);
        setMeta(data.meta || {});
    } catch (err) {
        setMaterials([]);
        setMeta({});
        console.error("Error fetching materials:", err);
    } finally {
        setLoadingMaterial(false);
    }
    };

    useEffect(() => {
        fetchMaterials(page);
    }, [page]);

    useEffect(() => {
        async function getPrograms() {
            try {
                const apiUrl = `${LMSBASEURL}/api/institutes/${instituteId}/programs`;

                const response = await fetch(apiUrl, {
                    method: 'GET',
                    headers: {
                        'Authorization': token,
                        'Accept': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`Unable to load programs. Please try again later. (${response.status})`);
                }

                const data = await response.json();
                if (data?.status && data?.data) {
                    setPrograms(
                        data?.data?.map(({ id, program_title }) => ({ value: id, label: program_title }))
                    );
                } else {
                    setPrograms([])
                    throw new Error("Invalid response format from server.");
                }
            } catch (err) {
                setPrograms([])
                console.log(err.message);
            }
        }
        getPrograms();
    }, []);

    useEffect(() => {
        if (!program) return;

        setCourses([]);
        setModules([]);
        setCourse(null);
        setModule(null);

        const fetchCourses = async () => {
            setLoadProgram(true)
            try {
                const apiUrl = `${LMSBASEURL}/api/courses-by-program`;
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers:myHeaders,
                    body:JSON.stringify({"program_ids": [program.value]})
                });
                const data = await response.json();

                const options = data?.data?.map((c) => ({
                    value: c.id,
                    label: c.title,
                })) || [];
                setCourses(options);
            } catch (err) {
                console.error("Error fetching courses:", err);
            }finally{
                setLoadProgram(false)
            }
        };

        fetchCourses();
    }, [program]);

    useEffect(() => {
        if (!course) return;

        setModules([]);
        setModule(null);

        const fetchModules = async () => {
            setLoadModule(true)
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Accept", "application/json");
            myHeaders.append("Content-Type", "application/json");
            try {
                const response = await fetch(`${LMSBASEURL}/api/course-modules`, {
                    method: "POST",
                    headers: myHeaders,
                    body: JSON.stringify({ course_ids: [course.value] }),
                });

                const data = await response.json();
                const options = data?.data?.map((m) => ({
                    value: m.id,
                    label: m.module_title,
                })) || [];
                setModules(options);
            } catch (err) {
                console.error("Error fetching modules:", err);
            }finally{
                setLoadModule(false)
            }
        };

        fetchModules();
    }, [course]);

    const validateForm = () => {
        const newErrors = {};

        if (!program) {
            newErrors.program = "Please Select Program Name";
        } 

        if (!course) {
            newErrors.course = "Please select Course";
        }

        if (!module) {
            newErrors.module = "Please select module.";
        }

        if (!file) {
            newErrors.file = "Please select File.";
        }

        if (filename=='') {
            newErrors.filename = "Please enter file name no special character allowed.";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        setLoading(true)
        if (validateForm()) {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Accept", "application/json");
    
            const formdata = new FormData();
            formdata.append("program_id", program.value);
            formdata.append("course_id", course.value);
            formdata.append("module_id", module.value);
            formdata.append("teacher_id", teacher ? teacher.value : "");
            formdata.append("institute_id", loginID);
            formdata.append("filename", filename || file.name);
            formdata.append("filepath", file, file.name);
    
            try {
                const response = await fetch(`${LMSBASEURL}/api/teacher-materials`,{
                    method: "POST",
                    headers: myHeaders,
                    body: formdata
                });
        
                const result = await response.json();
                if(result?.errors){
                    Swal.fire({
                        icon:"error",
                        title:"Upload failed!"
                    });
                }

                Swal.fire({
                    icon:"success",
                    title:"Material uploaded successfully!"
                });
                setShow(false)
                fetchMaterials(page);
                setProgram(null);
                setCourse(null);
                setModule(null);
                setTeacher(null);
                setFile(null);
                setFilename("");
            } catch (error) {
                console.error("Error uploading:", error);
                Swal.fire({
                    icon:"error",
                    title:"Upload failed!"
                });
            }finally{
                setLoading(false)
            }
        }
    };

    const handleEdit = (item) => {
        setEditItem(item);
        setFilename(item.filename);
        setFile(null);
        setShowEdit(true);
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        if (!editItem) return;

        const formdata = new FormData();
        formdata.append("filename", filename);
        if (file) {
            formdata.append("filepath", file, file.name);
        }

        try {
            setUploadLoad(true)
            const res = await fetch(`${LMSBASEURL}/api/teacher-materials/${editItem.id}/update`,{
                method: "POST",
                headers: {
                    Authorization: token,
                    Accept: "application/json",
                },
                body: formdata,
            });

            // const result = await res.json();
            Swal.fire({
                icon:"success",
                text:"Material updated successfully!"
            });
            setShowEdit(false);
            fetchMaterials(page);
        } catch (err) {
            Swal.fire({
                icon:"error",
                text:"Fail To update Material!"
            });
            console.error("Error updating:", err);
        }finally{
            setUploadLoad(false)
        }
    };

    // Handle Delete
    const handleDelete = async (id) => {
        try {
            const confirmResult = await Swal.fire({
                title: "Are you sure?",
                text: "This action will permanently delete the material.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "Cancel",
            });

            if (!confirmResult.isConfirmed) return;

            const res = await fetch(`${LMSBASEURL}/api/teacher-materials/${id}`, {
                method: "DELETE",
                headers: myHeaders,
            });

            const result = await res.json();

            Swal.fire("Deleted!", "Material has been deleted successfully.", "success");

            fetchMaterials(page);
        } catch (err) {
            console.error("Error deleting:", err);
            Swal.fire("Error!", "Something went wrong while deleting.", "error");
        }
    };


    // Render pagination
    const renderPagination = () => {
    if (!meta.total || meta.last_page <= 1) return null;

    let items = [];
    for (let i = 1; i <= meta.last_page; i++) {
        items.push(
        <Pagination.Item
            key={i}
            active={i === meta.current_page}
            onClick={() => setPage(i)}
        >
            {i}
        </Pagination.Item>
        );
    }

    return <Pagination>{items}</Pagination>;
    };

    const handleFileName=(e)=>{
        const { value} = e.target;
        setFilename(value.replace(/[^A-Za-z0-9 ]/g, ""))
    }

    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            border: "1px solid #ced4da",
            boxShadow: "none",
            "&:hover": {
            border: "1px solid #ced4da",
            },
            minHeight: "38px",
            fontSize: "14px",
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "#495057",
        }),
    }

    const handleMaterialDownload = (material) => {
        if (!material.filepath) {
            Swal.fire({
                icon: 'error',
                title: 'Download Failed',
                text: 'Material file path not found',
                confirmButtonColor: '#007bff'
            });
            return;
        }

        const link = document.createElement('a');
        link.href = material.filepath;
        link.download = material.filename || 'download';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    if(loadingMaterial){
        return(
            <div className="py-4">
                <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                </div>
            </div>
        )
    }

    return (
        <>
            <div className="d-flex justify-content-between align-content-center">
                <h3>Teacher Materials</h3>
                <Button variant="primary" onClick={() => setShow(true)}>
                    Upload Material
                </Button>
            </div>

            {materials.length === 0 ? <NoDataFound className="border mt-4 rounded-3" message="No materials found."/>:
            <>
            {/* Table view for desktop */}
            <div className="d-none d-md-block">
                <div className="table-responsive">
                <Table striped bordered hover className="mt-3 rounded-3">
                    <thead>
                        <tr>
                        <th>ID</th>
                        <th>Filename</th>
                        <th style={{
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis", 
                                overflow:"hidden"
                            }}>Course Title</th>
                        <th style={{
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis", 
                                overflow:"hidden"
                            }}>Module Name</th>
                        <th style={{
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis", 
                                overflow:"hidden"
                            }}>Uploaded At</th>
                        <th>File</th>
                        <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {materials.length > 0 ? (
                        materials.map((item) => (
                            <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.filename}</td>
                                <td>{item.course_title}</td>
                                <td>{item.module_name}</td>
                                <td>{new Date(item.created_at).toLocaleString()}</td>
                                <td onClick={()=>handleMaterialDownload(item)} role="button">
                                    <span className="text-primary">Download File <i className="bi bi-download pl-2"></i></span>
                                </td>
                                <td>
                                    <Button
                                        variant="warning"
                                        size="sm"
                                        className="me-2"
                                        onClick={() => handleEdit(item)}
                                    >
                                    Edit
                                    </Button>
                                    <Button
                                        variant="danger"
                                        size="sm"
                                        onClick={() => handleDelete(item.id)}
                                    >
                                    Delete
                                    </Button>
                                </td>
                            </tr>
                        ))
                        ) : (
                        <tr>
                            <td colSpan="7" className="text-center">
                            No materials found.
                            </td>
                        </tr>
                        )}
                    </tbody>
                </Table>
                </div>
            </div>

            {/* Card view for mobile */}
            <div className="d-md-none">
                <Row className="mt-3">
                    {materials.length > 0 ? (
                        materials.map((item) => (
                            <Col xs={12} key={item.id} className="mb-3">
                                <div className="card shadow-sm">
                                    <div className="card-body">
                                        <h5 className="card-title text-truncate">{item.filename}</h5>
                                        <div className="d-flex justify-content-between mb-2">
                                            <small className="text-muted">ID: {item.id}</small>
                                            <small className="text-muted">{new Date(item.created_at).toLocaleString()}</small>
                                        </div>
                                        <div className="mb-2 d-flex align-items-baseline">
                                            <strong className="me-1">Course:</strong>
                                            <span className="text-truncate d-inline-block" style={{maxWidth: "100%"}}>{item.course_title}</span>
                                        </div>
                                        <div className="mb-3 d-flex align-items-baseline">
                                            <strong className="me-1">Module:</strong>
                                            <span className="text-truncate d-inline-block" style={{maxWidth: "100%"}}>{item.module_name}</span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <div 
                                                className="btn btn-sm btn-outline-primary" 
                                                onClick={()=>handleMaterialDownload(item)}
                                            >
                                                <i className="bi bi-download me-1"></i> Download
                                            </div>
                                            <div className="btn-group">
                                                <Button
                                                    variant="warning"
                                                    size="sm"
                                                    className="me-2"
                                                    onClick={() => handleEdit(item)}
                                                >
                                                    <i className="bi bi-pencil"></i> Edit
                                                </Button>
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={() => handleDelete(item.id)}
                                                >
                                                    <i className="bi bi-trash"></i> Delete
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        ))
                    ) : (
                        <Col xs={12}>
                            <div className="text-center p-4">
                                No materials found.
                            </div>
                        </Col>
                    )}
                </Row>
            </div>
            </>}

    
            {renderPagination()}
            
            <Offcanvas show={show} onHide={() => setShow(false)} placement="end">
                <Offcanvas.Header closeButton>
                <Offcanvas.Title>Upload Teacher Material</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                <Form 
                onSubmit={e => { 
                    e.preventDefault(); 
                    handleSubmit(e)
                }}
                // onSubmit={handleSubmit}
                >
                    <Row className="mb-3">
                    <Col md={12}>
                        <Form.Label>Program</Form.Label>
                        <Select
                        options={programs}
                        value={program}
                        onChange={setProgram}
                        styles={customSelectStyles}
                        components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                        placeholder="Select Program"
                        />
                        {errors.program && <div className="invalid-feedback">{errors.program}</div>}
                    </Col>
                    </Row>

                    <Row className="mb-3">
                    <Col md={12}>
                        <Form.Label>Course</Form.Label>
                        <Select
                            options={courses}
                            value={course}
                            onChange={setCourse}
                            placeholder="Select Course"
                            isDisabled={!program}
                            components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                            isLoading={loadProgram}
                        />
                        {errors.course && <div className="invalid-feedback">{errors.course}</div>}    
                    </Col>
                    </Row>

                    <Row className="mb-3">
                    <Col md={12}>
                        <Form.Label>Module</Form.Label>
                        <Select
                            options={modules}
                            value={module}
                            onChange={setModule}
                            placeholder="Select Module"
                            isDisabled={!course}
                            components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                            isLoading={loadModule}
                        />
                        {errors.module && <div className="invalid-feedback">{errors.module}</div>}    
                    </Col>
                    </Row>

                    {/* <Row className="mb-3">
                        <Col md={12}>
                            <Form.Label>Teacher (Optional)</Form.Label>
                            <Select
                                options={teachers}
                                value={teacher}
                                onChange={setTeacher}
                                placeholder="Select Teacher (or leave blank)"
                                isClearable
                            />
                        </Col>
                    </Row> */}

                    <Row className="mb-3">
                    <Col md={12}>
                        <Form.Label>File Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter filename"
                            value={filename}
                            onChange={handleFileName}
                        />
                        {errors.filename && <div className="invalid-feedback">{errors.filename}</div>}    
                    </Col>
                    </Row>

                    <Row className="mb-3">
                    <Col md={12}>
                        <Form.Label>Upload File</Form.Label>
                        <Form.Control
                            type="file"
                            onChange={(e) => setFile(e.target.files[0])}
                        />
                        
                    </Col>
                    </Row>

                    <Button type="submit" variant="success" className="w-100">
                        {loading ? <Spinner animation="border" size="sm" /> : "Upload"}
                    </Button>
                </Form>
                </Offcanvas.Body>
            </Offcanvas>

            <Offcanvas
                show={showEdit}
                onHide={() => setShowEdit(false)}
                placement="end"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Edit Material</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form onSubmit={handleUpdate}>
                    <Form.Group className="mb-3">
                        <Form.Label>Filename</Form.Label>
                        <Form.Control
                        type="text"
                        value={filename}
                        onChange={(e) => setFilename(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Upload New File (optional)</Form.Label>
                        <Form.Control
                        type="file"
                        onChange={(e) => setFile(e.target.files[0])}
                        />
                    </Form.Group>
                    <Button type="submit" variant="success" >
                        {uploadLoad ? <Spinner animation="border" size="sm" /> : "Save"}
                    </Button>
                    </Form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default TeacherMaterialPage;
